module.exports = require("@material-ui/core/AppBar");